// Vendor
import { createAction, props } from '@ngrx/store';
export const setFundChartNote = createAction('[Fund Chart] Set note', props());
